import { isIos } from './isIos'

export async function attemptToAutoOpenPdf(url: string, target: '_blank' | '_self' = '_blank') {
  if (isIos()) {
    return {
      result: 'failure',
    } as const
  }
  else {
    try {
      const openedPdfWindow = window.open(
        url,
        target,
      )

      await new Promise(resolve => setTimeout(resolve, 300))
      if (!openedPdfWindow) {
        return {
          result: 'failure',
        } as const
      }
      openedPdfWindow?.focus()

      return {
        result: 'success',
      } as const
    }
    catch {
      return {
        result: 'failure',
      } as const
    }
  }
}
